// extracted by mini-css-extract-plugin
export default {"wrapper":"MessageCenter_wrapper__WxeoE","active":"MessageCenter_active__Ch+xb","users":"MessageCenter_users__CdLL2","messages":"MessageCenter_messages__pPbaT"};